module.exports = __webpack_public_path__ + "img/Red Velvet Cake.f98b5fbb.svg";